import slugify from 'slugify'
import { paramCase } from 'param-case'

const toSlug = (string) => {
  return slugify(string, {
    replacement: '-',
    trim: true,
    strict: true,
    lower: true,
    locale: 'de',
  })
}

const toCssName = (string) => {
  return paramCase(string)
}

export {
  toSlug,
  toCssName,
}
